import AboutUs from "./AboutUs";
import TitleText from "./TitleText";
import ImageTitleText from "./ImageTitleText";
import PictureCatalog from "./PictureCatalog";
import Deals from "./Deals";
import Store from "./Store";
import Website from "./Website";
import Rewards from "./Rewards";
import Punchcards from "./Punchcards";

export default {
  aboutUs: <AboutUs />,
  titleText: <TitleText />,
  imageTitleText: <ImageTitleText />,
  pictureCatalog: <PictureCatalog />,
  website: <Website />,
  deals: <Deals />,
  store: <Store />,
  rewards: <Rewards />,
  punchCard: <Punchcards />,
};
